export enum ResignationLinkPlacement {
  Mail = 'mail_travel',
  Typ = 'typ_travel',
}
